import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route as DomRoute, matchPath, withRouter } from 'react-router-dom';

class Route extends Component {
  static propTypes = {
    disableScroll: PropTypes.bool,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    path: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        to: PropTypes.string,
        state: PropTypes.object,
        query: PropTypes.object,
        search: PropTypes.string,
      }),
    ]),
  };
  static defaultProps = {
    path: undefined,
    disableScroll: false,
  };
  static contextTypes = {
    changeLayoutProps: PropTypes.func,
  };

  async componentDidMount() {
    const { disableScroll, location, path, history, layoutProps } = this.props;
    const { changeLayoutProps } = this.context;

    if (matchPath(location.pathname, { path, exact: true })) {
      const isModal = location.state && location.state.modal;
      const isActionPop = (location.state && location.state.action === 'POP') || history.action === 'POP';

      if (!disableScroll && !isModal && !isActionPop) {
        window.scrollTo(0, 0);
      }

      if (layoutProps) {
        changeLayoutProps(layoutProps);
      }
    }
  }

  async componentWillUpdate({ location: nextLocation, path, history, layoutProps: nextLayoutProps }) {
    const {
      disableScroll,
      layoutProps,
      location: { pathname: currentPathname },
    } = this.props;
    const { changeLayoutProps } = this.context;

    if (
      nextLocation.pathname !== currentPathname &&
      matchPath(nextLocation.pathname, {
        path,
        exact: true,
      })
    ) {
      const isModal = nextLocation.state && nextLocation.state.modal;
      const isActionPop = (nextLocation.state && nextLocation.state.action === 'POP') || history.action === 'POP';

      if (!disableScroll && !isModal && !isActionPop) {
        window.scrollTo(0, 0);
      }

      if (layoutProps !== nextLayoutProps) {
        changeLayoutProps(nextLayoutProps);
      }
    }
  }

  render() {
    const { disableScroll, ...props } = this.props;

    return <DomRoute {...props} />;
  }
}

export default withRouter(Route);
